// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import type { IconProps } from '@tls/treact-ui/icons';
import React from 'react';

const IconTiles = ({ id, width, height, viewBox, strokeWidth, stroke, fill, ...other }: IconProps) => {
  return (
    <svg
      id={id ?? 'svg-tiles'}
      data-name='svg-tiles'
      data-testid='svg-tiles'
      xmlns='http://www.w3.org/2000/svg'
      width={width ?? '36'}
      height={height ?? '36'}
      viewBox={viewBox ?? '0 0 36 36'}
      strokeWidth={strokeWidth ?? '0'}
      stroke={stroke ?? 'currentColor'}
      fill={fill ?? 'currentColor'}
      {...other}
    >
      <path
        d='M27.05 14.949H33.05V8.89801H27.05V14.949ZM15.05 14.949H21.05V8.89801H15.05V14.949ZM3.05078 14.949H9.05003V8.89801H3.05078V14.949ZM27.05 27H33.05V20.9483H27.05V27ZM15.05 27H21.05V20.9483H15.05V27ZM3.05078 27H9.05003V20.9483H3.05078V27Z'
        fill='black'
        stroke='black'
      />
    </svg>
  );
};

export default IconTiles;
